<div class="container">
  <div class="container-header">
    <div class="title">A new integration was created</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="close()" />
  </div>
  <div class="container-body">
    <div class="title">Let's continue to edit the default policy and configure the company's 'Trusted Domains'.</div>
  </div>
  <div class="container-footer">
    <div class="confirm" (click)="onConfirm()">Go</div>
  </div>
</div>
